import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: 'app-use-and-sale',
  standalone: true,
  imports: [TranslatePipe, CommonModule],
  templateUrl: './use-and-sale.component.html',
  styleUrl: './use-and-sale.component.scss'
})
export class UseAndSaleComponent {

}
